import NewsCardGrid from '@leuven2030/food/News/NewsCardGrid';
import React, { useContext } from 'react';
import 'twin.macro';
import { PageContext } from '@leuven2030/framework/Page/Page';
import { StyleContent } from '@leuven2030/food/styles/general';
import NewsButton from '@leuven2030/food/News/NewsButton';
const NewsRecommendations = () => {
  const {
    prismic: {
      news_page: { recommendations_title, title: newsTitle, _meta: newsMeta },
      news_article: {
        _meta: { uid }
      },
      allNews_articles: { edges }
    }
  } = useContext(PageContext);

  const filteredEdges = edges.slice(0, 4).filter(({ node }) => {
    if (node._meta.uid == uid) {
      return;
    }

    return true;
  });

  return (
    <div tw="bg-gray-100 py-16">
      <div tw="space-y-16 " css={StyleContent}>
        <h2 tw="text-3xl">{recommendations_title}</h2>
        <NewsCardGrid edges={filteredEdges} />
        <NewsButton />
      </div>
    </div>
  );
};

export default NewsRecommendations;
